import { render, staticRenderFns } from "./actitem.vue?vue&type=template&id=654a72a1"
import script from "./actitem.vue?vue&type=script&lang=js"
export * from "./actitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports